import axios from "axios";
import BunkeyAPI from "../api/BunkeyAPI";
import { ENDPOINT } from "../utils/index";
import jwtDecode from "jwt-decode";
import store from "../store";
import {
  ASSET_PUBLIC_SHARED_GET_DATA,
  ASSET_PUBLIC_SHARED_GET_DATA_SUCCESS,
  ASSET_PUBLIC_SHARED_GET_DATA_FAILURE,
  ASSET_PUBLIC_NAVIGATE_SHARED_DATA_SUCCESS,
  ASSET_PUBLIC_SHARED_EXPAND_SELECT,
  ASSET_PUBLIC_SHARED_EXPAND_UNSET_SELECT,
  PUBLIC_SHARED_SET_SELECT,
  PUBLIC_SHARED_UNSET_SELECT,
  PUBLIC_SHARED_ACTIVEVIEW,
  ASSET_HAS_PASSWORD,
  ASSET_HAS_PASSWORD_SUCCESS,
  ASSET_HAS_PASSWORD_FAILURE,
  ASSETS_PUBLIC_MULTI_MOVE,
  ASSETS_PUBLIC_MULTI_MOVE_SUCCESS,
  ASSETS_PUBLIC_MULTI_MOVE_FAILURE
} from "../constants/assets-public-shared-types";

import { sendNotification } from "../utils";

export const getPublicShared = (webToken, intl, password, page = 1) => {
  return dispatch => {
    dispatch({ type: ASSET_PUBLIC_SHARED_GET_DATA });
    axios
      .post(`${ENDPOINT}shared/validate`, {
        webToken,
        password
      })
      .then(resp => {
        if (!resp.data.accessToken) {
          if (resp.data.value === "password is required") {
            dispatch({
              type: ASSET_HAS_PASSWORD
            });
          } else if (resp.data.value === "password incorrect") {
            dispatch({
              type: ASSET_HAS_PASSWORD_FAILURE
            });
          }
        } else {
          dispatch({
            type: ASSET_HAS_PASSWORD_SUCCESS,
            payload: {
              accessToken: resp.data.accessToken,
              password: resp.data.password
            }
          });
          const accessToken = resp.data.accessToken;
          const decode = jwtDecode(resp.data.accessToken);
          const client = decode.user.client;
          const object = decode.user.object;

          axios
            .get(`${ENDPOINT}clients/${client}/objects/${object}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`
              }
            })
            .then(resp => {
              let nameSharedAsset = "";
              if (resp.data.length > 0) nameSharedAsset = resp.data[0].length;
              else nameSharedAsset = intl.formatMessage({ id: "share_public" });
              dispatch({
                type: ASSET_PUBLIC_SHARED_GET_DATA_SUCCESS,
                payload: {
                  data: [resp.data],
                  headers: resp.headers,
                  webToken: webToken,
                  nameSharedAsset: nameSharedAsset
                }
              });
            })
            .catch(err => {
              dispatch({
                type: ASSET_PUBLIC_SHARED_GET_DATA_FAILURE,
                payload: err
              });
            });
        }
      })
      .catch(err => {
        dispatch({
          type: ASSET_PUBLIC_SHARED_GET_DATA_FAILURE,
          payload: err
        });
      });
  };
};
export const getPublicMultiShared = (webToken, intl, password, page = 1) => {
  return dispatch => {
    dispatch({ type: ASSET_PUBLIC_SHARED_GET_DATA });
    axios
      .post(`${ENDPOINT}shared/validatemultishared`, {
        webToken,
        password
      })
      .then(resp => {
        if (!resp.data.accessToken) {
          if (resp.data.value === "password is required") {
            dispatch({
              type: ASSET_HAS_PASSWORD
            });
          } else if (resp.data.value === "password incorrect") {
            dispatch({
              type: ASSET_HAS_PASSWORD_FAILURE
            });
          }
        } else {
          dispatch({
            type: ASSET_HAS_PASSWORD_SUCCESS,
            payload: {
              accessToken: resp.data.accessToken,
              password: resp.data.password
            }
          });
          const accessToken = resp.data.accessToken;
          const decode = jwtDecode(resp.data.accessToken);
          const client = decode.user.client;
          const sharedId = decode.user.shared;

          axios
            .get(`${ENDPOINT}clients/${client}/shared/${sharedId}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`
              }
            })
            .then(resp => {
              dispatch({
                type: ASSET_PUBLIC_SHARED_GET_DATA_SUCCESS,
                payload: {
                  data: resp.data,
                  headers: resp.headers,
                  webToken: webToken,
                  nameSharedAsset: "Compartidos"
                }
              });
            })
            .catch(err => {
              dispatch({
                type: ASSET_PUBLIC_SHARED_GET_DATA_FAILURE,
                payload: err
              });
            });
        }
      })
      .catch(err => {
        dispatch({
          type: ASSET_PUBLIC_SHARED_GET_DATA_FAILURE,
          payload: err
        });
      });
  };
};

export const navigatePublicSharedFolder = (
  webToken,
  folderId,
  foldername,
  password,
  page = 1
) => {
  return dispatch => {
    dispatch({ type: ASSET_PUBLIC_SHARED_GET_DATA });
    axios
      .post(`${ENDPOINT}shared/validate`, {
        webToken,
        password
      })
      .then(resp => {
        const accessToken = resp.data.accessToken;
        const decode = jwtDecode(resp.data.accessToken);
        const client = decode.user.client;

        setTimeout(() => {
          axios
            .get(
              `${ENDPOINT}clients/${client}/folders/${folderId}?page=${page}&limit=20`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${accessToken}`
                }
              }
            )
            .then(resp => {
              const folderEnter = { id: folderId, name: foldername };
              let sharedBreadCrumb = store.getState().assetsPublicShared
                .sharedBreadCrumb;

              if (sharedBreadCrumb.length === 0) {
                sharedBreadCrumb = [...sharedBreadCrumb, folderEnter];
              } else {
                if (
                  sharedBreadCrumb.findIndex(r => r.id === folderEnter.id) ===
                  -1
                ) {
                  sharedBreadCrumb = [...sharedBreadCrumb, folderEnter];
                } else {
                  sharedBreadCrumb = sharedBreadCrumb.slice(
                    0,
                    sharedBreadCrumb.findIndex(r => r.id === folderEnter.id) + 1
                  );
                }
              }

              dispatch({
                type: ASSET_PUBLIC_NAVIGATE_SHARED_DATA_SUCCESS,
                payload: {
                  data: resp.data,
                  headers: resp.headers,
                  accessToken: accessToken,
                  webToken: webToken,
                  folderselect: folderId,
                  nameSharedAsset: foldername,
                  sharedBreadCrumb: sharedBreadCrumb,
                  page: page
                }
              });
            })
            .catch(err => {
              dispatch({
                type: ASSET_PUBLIC_SHARED_GET_DATA_FAILURE,
                payload: err
              });
            });
        }, 500);
      })
      .catch(err => {
        dispatch({
          type: ASSET_PUBLIC_SHARED_GET_DATA_FAILURE,
          payload: err
        });
      });
  };
};

export const setSelectExpandPublicSharedAsset = asset => {
  return dispatch => {
    dispatch({
      type: ASSET_PUBLIC_SHARED_EXPAND_SELECT,
      payload: {
        data: asset
      }
    });
  };
};

export const unsetSelectExpandPublicSharedAsset = () => {
  return dispatch => {
    dispatch({
      type: ASSET_PUBLIC_SHARED_EXPAND_UNSET_SELECT,
      payload: {}
    });
  };
};

export const setSelectPublicShared = (
  item,
  indice,
  from,
  verticalCount,
  horizontalCount
) => {
  return dispatch => {
    dispatch({
      type: PUBLIC_SHARED_SET_SELECT,
      payload: {
        data: item,
        indice,
        from,
        verticalCount,
        horizontalCount
      }
    });
  };
};

export const unsetSelectPublicShared = () => {
  return dispatch => {
    dispatch({ type: PUBLIC_SHARED_UNSET_SELECT });
  };
};

export const setPublicSharedActiveView = view => {
  return dispatch => {
    dispatch({
      type: PUBLIC_SHARED_ACTIVEVIEW,
      payload: {
        activeView: view
      }
    });
  };
};
export const moveMultiselectPublicAsset = (workclient, ids, folder, intl) => {
  return dispatch => {
    dispatch({ type: ASSETS_PUBLIC_MULTI_MOVE });
    BunkeyAPI({
      url: `/clients/${workclient}/objects-movemany/${folder}`,
      method: "PUT",
      data: {
        data: ids
      }
    })
      .then(resp => {
        dispatch({
          type: ASSETS_PUBLIC_MULTI_MOVE_SUCCESS,
          payload: {
            ids: ids,
            headers: resp.headers
          }
        });
        // if (multiple) {
        sendNotification(
          "success",
          intl,
          intl.formatMessage({ id: "assets_have_been_moved" })
        );
        // }
      })
      .catch(err => {
        dispatch({
          type: ASSETS_PUBLIC_MULTI_MOVE_FAILURE,
          payload: err
        });
        sendNotification(
          "error",
          intl,
          `${intl.formatMessage({ id: "assets_could_not_moved" })}`
        );
      });
  };
};
